import React from "react";
import ContactForm from "../ContactFrom";
import "./style.css";

const Contactpage = () => {
  return (
    <section className="wpo-contact-form-map">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="wpo-contact-info">
              <div className="contact-info-header">
                <h3>Contact Information</h3>
              </div>
              <div className="contact-info-list">
                <div className="contact-info-item">
                  <div className="contact-icon">
                    <i className="ti-location-pin"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Office Address</h4>
                    <p>
                      West Boragaon, Near Bangshi Gopal Namghar Path,
                      <br />
                      Guwahati. PO- Maligaon, Pin:- 781011
                    </p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    <i className="ti-email"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Email Address</h4>
                    <p>
                      <a href="mailto:nirbaakworld@gmail.com">
                        nirbaakworld@gmail.com
                      </a>
                    </p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    <i className="ti-mobile"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Phone Numbers</h4>
                    <p>
                      <a href="tel:+918486322013">+91 8486322013</a> /
                      <a href="tel:+918638453757">8638453757</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="contact-form">
                  <h2>Get In Touch</h2>
                  <ContactForm />
                </div>
              </div>
              <div className="col col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="contact-map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3582.204908397114!2d91.68600837541256!3d26.124861077125555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDA3JzI5LjUiTiA5McKwNDEnMTguOSJF!5e0!3m2!1sen!2sin!4v1754001329912!5m2!1sen!2sin"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Nirbaak Office Location Map"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contactpage;
